import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showModal } from '~/actions/runtime';
import { BOOKING_TIME_SELECTOR_MODAL } from '~/components/ClinicDetailPageFlexible/components/BookModule/components/Modal';
import { setCurrentlySelectedLocation } from '~/ducks/currentlySelectedLocation';
import { LocationContext } from '~/components/ClinicDetailPageFlexible/ContextProviders';
import { useBreakpoint } from '~/hooks/useBreakpoint';
import useIsClientSide from '~/hooks/useIsClientSide';

export const useStartBooking = () => {
  const dispatch = useDispatch();
  const isClientSide = useIsClientSide();
  const { location, associatedTelemedLocation } = useContext(LocationContext);
  const [useAssociatedTelemed, setUseAssociatedTelemed] = useState(false);
  const [triggered, setTriggered] = useState(false);
  const hasMobileContainer = !useBreakpoint('md', 'above');

  const startBooking = useCallback(() => {
    if (hasMobileContainer) {
      dispatch(showModal(BOOKING_TIME_SELECTOR_MODAL));
    }

    dispatch(
      setCurrentlySelectedLocation(
        useAssociatedTelemed ? associatedTelemedLocation ?? location : location
      )
    );
  }, [associatedTelemedLocation, dispatch, hasMobileContainer, location, useAssociatedTelemed]);

  useEffect(() => {
    if (triggered && isClientSide) {
      startBooking();
      setTriggered(false);
    }
  }, [isClientSide, startBooking, triggered]);

  /**
   * Starts the booking process by setting the location and opening the booking modal on mobile.
   *
   * @param useAssociatedTelemed Indicator for if the associated telemed should be used for booking (E.g. Video visit tab)
   */
  return (useAssociatedTelemed?: boolean) => {
    setUseAssociatedTelemed(!!useAssociatedTelemed);
    setTriggered(true);
  };
};
